import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar } from '@ionic/react';

import './Reservation_EnterBookingInfo_locals.css';

import { Geolocation } from '@capacitor/geolocation';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/zPublic.css';

export function GPSC_Component (props) {


let authMerchant_objects = useContext(Auth_MerchantID_context);

const [coordinates, setCoordinates] = useState(null);
const [distance_miles, setDistance_miles] = useState(null);

let [latitudeCurrent, setLatitudeCurrent ] = useState(authMerchant_objects.latitudeCurrent);
let [longitudeCurrent, setLongitudeCurrent ] = useState(authMerchant_objects.longitudeCurrent);


function calculateDistance (lat1, lon1, lat2, lon2) {

    //alert(lat1);
    //alert(lon1);
    //alert(lat2);
    //alert(lon2);

    const R = 3958.8; // Radius of Earth in miles
    const φ1 = lat1 * (Math.PI / 180); // Convert degrees to radians
    const φ2 = lat2 * (Math.PI / 180);
    const Δφ = (lat2 - lat1) * (Math.PI / 180); // Difference in latitudes
    const Δλ = (lon2 - lon1) * (Math.PI / 180); // Difference in longitudes
  
    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
    const distance = R * c; // Distance in miles

    //alert(distance);

    return distance;
  };

async function getCurrentLocation() {
    try{

        alert("in Get Coordinates");


        let position = await Geolocation.getCurrentPosition();

        alert(JSON.stringify(position, null, 2));

        setCoordinates(position.coords);

        //alert(position.coords);
        // alert(props.data.companyLatitude);
        // alert(props.data.companyLongitude);
        // alert(position.coords.latitude);
        // alert(position.coords.longitude);

       // alert(coordinates.longitude);
       // alert(coordinates.longitude);

        //setDistance_miles(calculateDistance(props.data.companyLatitude, props.data.companyLongitude, position.coords.latitude, position.coords.longitude));

    }
    catch(error)
    {
        console.error('Error getting location:', error);
    }
}

useEffect(() => {

//alert("in USE EFFECT GEOLOCATION");


     //getCurrentLocation();

     setDistance_miles(calculateDistance(props.data.companyLatitude, props.data.companyLongitude, latitudeCurrent, longitudeCurrent));


   }, [])

return (
    <React.Fragment>

                {/*{coordinates != null && <IonText>Latitude: {coordinates.latitude}, Longitude {coordinates.longitude}</IonText>}*/}

                {distance_miles != null && <IonText  style={{ fontSize: '.8rem' }}>{distance_miles.toFixed(2)} mi</IonText>}
                    
                {/*{coordinates == null &&  <IonText>Loading location...</IonText>}*/}

    </React.Fragment>)
}